import { render } from "./ProfileChangePassword.vue?vue&type=template&id=cf81ce9e"
import script from "./ProfileChangePassword.vue?vue&type=script&lang=js"
export * from "./ProfileChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__